import { useEffect, useState } from 'react';
import { UseFetchStatesType } from '../lib/types/types';
import GetRecord from '../lib/api/GetRecord';
import { get } from 'lodash';
import { removeDataKeys, removeNullDeep } from '../utils/helper';
import { APIS } from '../lib/constants/apis';
import POP_LEVEL from '../lib/api/Populations.json';

function useFetchOrganisationDetails(id: number): UseFetchStatesType {
	const [loading, setLoading] = useState<boolean>(false);
	const [data, setData] = useState<any[]>([]);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		// Fetch data
		const fetchData = async () => {
			try {
				const res = await GetRecord(APIS.Organisation, id, POP_LEVEL.organisation.FULL);
				const result: any[] = removeNullDeep(removeDataKeys(get(res, 'data', [])));
				setData(result);
			} catch (err: any) {
				setError(err.message);
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, [id]);

	return { loading, data, error };
}
export { useFetchOrganisationDetails };
